import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
function Fivpic() {
  return (
    <div>
 <Container>

        
<Row>
  <Col>
  <div className="par">
<div id="shop"><b>Shopping Now</b></div>

  <div id="line"></div>
  <div id="cate">CATEGORY</div>
  <div id="line"></div>
  <div id="cate">STYLING</div>
  <div id="line"></div>
  <div id="cate">COLOR FAMILY</div>
  <div id="line"></div>
  <div id="cate">SEASON</div>
  <div id="line"></div>
  <div id="cate">PRODUCT CATEGORY</div> 
  <div id="line"></div>
  <div id="cate">SIZE</div>
   <div id="line"></div>
  <div id="cate">FABRIC</div>
</div></Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0022_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0032_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0023_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>
   
    <Container>

        
<Row>
  <Col>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0026_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223 <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0027_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223
 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0031_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>
    <Container>

        
<Row>
  <Col>
  </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0022_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0032_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0023_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>
    <Container>

        
<Row>
  <Col>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0026_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223 <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0027_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223
 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/s/w/swt-0031_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>
    <Useletter/>
<Foter/>
    </div>
  )
}

export default Fivpic